import script from "./Certification.vue?vue&type=script&setup=true&lang=js"
export * from "./Certification.vue?vue&type=script&setup=true&lang=js"

import "./Certification.vue?vue&type=style&index=0&id=e7c4aafa&lang=less&scoped=true"

import exportComponent from "/data/web/pay/brpay/brpay-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e7c4aafa"]])

export default __exports__